import twitterApi from '../../../../common/apis/twitterApi';
import type { Clip } from '../../clipQueueSlice';
import type { ClipProvider } from '../providers';
import { createLogger } from '../../../../common/logging';

const logger = createLogger('TwitterProvider');

class TwitterProvider implements ClipProvider {
  name = 'twitter';

  getIdFromUrl(url: string): string | undefined {
    try {
      console.log('[TwitterProvider] getIdFromUrl called with:', url);
      const uri = new URL(url);
      console.log('[TwitterProvider] Hostname:', uri.hostname, 'Pathname:', uri.pathname);

      if (uri.hostname.match(/^(www\.)?(twitter|x)\.com$/)) {
        console.log('[TwitterProvider] Hostname matches Twitter/X pattern');
        const match = uri.pathname.match(/\/\w+\/status\/(\d+)/);

        if (match) {
          const usernameMatch = uri.pathname.match(/\/([\w]+)\/status/);
          const username = usernameMatch ? usernameMatch[1] : null;
          const result = username ? `${username}:${match[1]}` : match[1];
          console.log('[TwitterProvider] Extracted ID:', result);
          return result;
        } else {
          console.log('[TwitterProvider] Path did not match status pattern');
        }
      } else {
        console.log('[TwitterProvider] Hostname did not match Twitter/X pattern');
      }
      return undefined;
    } catch (error) {
      console.error('[TwitterProvider] Error parsing URL:', error);
      return undefined;
    }
  }

  async getClipById(id: string): Promise<Clip | undefined> {
    if (!id) return undefined;
    const [username, tweetId] = id.includes(':') ? id.split(':') : [undefined, id];

    logger.info('Fetching Twitter clip info for ID:', id, '(username:', username, 'tweetId:', tweetId, ')');
    const clipInfo = await twitterApi.getClip(tweetId, username);

    if (!clipInfo) {
      logger.warn('No clip info returned from Twitter API for ID:', id);
      return undefined;
    }

    logger.info('Twitter clip info received:', clipInfo);

    const clip = {
      id,
      title: `Tweet by ${clipInfo.author_name}`,
      author: clipInfo.author_name,
      url: clipInfo.url,
      thumbnailUrl: undefined, // Twitter oEmbed doesn't provide thumbnails
      submitters: [],
      Platform: 'Twitter' as const,
    };

    logger.info('Returning Twitter clip:', clip);
    return clip;
  }

  getUrl(id: string): string | undefined {
    const [username, tweetId] = id.includes(':') ? id.split(':') : [undefined, id];
    return username
      ? `https://twitter.com/${username}/status/${tweetId}`
      : `https://twitter.com/i/status/${tweetId}`;
  }

  getEmbedUrl(id: string): string | undefined {
    return this.getUrl(id);
  }

  async getAutoplayUrl(id: string): Promise<string | undefined> {
    return undefined; // Twitter embeds don't support direct video playback
  }
}

const twitterProvider = new TwitterProvider();
export default twitterProvider;
